import { useEffect, useState } from "react";
import {
  useAlertStore,
  usePopupStore,
  useThemeStore,
  useUserStore,
} from "../../../stores";
import { Column, Row } from "../../../components/containers";
import {
  AlignItems,
  JustifyContent,
  Wrap,
} from "../../../components/containers/types";
import { PopupBack, PopupClose } from "../../../popup";
import { Heading } from "../../../components/typography";
import { TagInput, TextInput } from "../../../components/inputs";
import { Button } from "../../../components/buttons";
import { CustomerApi } from "../../../api";
import { CustomerEditPopupProps } from "./types";

const CustomerEditPopup = <T extends {}>(props: CustomerEditPopupProps<T>) => {
  const {
    address,
    fullname,
    national_code,
    phone,
    tags,
    readOnly = false,
  } = props;
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const theme = useThemeStore((s) => s.theme);
  const pushAlert = useAlertStore((s) => s.pushAlert);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxWidth: 816,
        maxHeight: "80%",
        overflowY: "auto",
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [_fullname, setFullname] = useState<string>("");
  const [_nationalCode, setNationalCode] = useState<string>("");
  const [_phone, setPhone] = useState<string>("");
  const [_address, setAddress] = useState<string>("");
  const [_tags, setTags] = useState<Array<string>>(tags.map((t) => t.$oid));

  const [loading, setLoading] = useState<boolean>(false);
  const hasUserAccess = useUserStore((s) => s.hasUserAccess);

  const onEdit = (): void => {
    if (!hasUserAccess(["AddEditCustomer"]))
      return pushAlert("دسترسی غیر مجاز", "error");
    setLoading(true);
    CustomerApi.editCustomer(
      props._id.$oid,
      _fullname,
      _nationalCode,
      _phone,
      _address,
      _tags
    )
      .then(() => {
        setPopupBody(
          props.back ? <props.back.component {...props.back.props} /> : null
        );
        pushAlert("عملیات موفقیت آمیز");
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Column
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Start}
      style={{ marginBottom: "1rem", position: "relative" }}
      gap={20}
    >
      <PopupClose />

      {props.back ? (
        <PopupBack Component={props.back.component} props={props.back.props} />
      ) : (
        <></>
      )}

      <Heading
        textStyles={{ marginTop: "1rem" }}
        size={19}
        color={theme.textOnOverlay}
      >
        ویرایش مشتری
      </Heading>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.Between}
        gap={20}
        flexWrap={Wrap.Wrap}
        className="customer-activity-popup-row"
      >
        <TextInput
          style={{ maxWidth: 300 }}
          label="نام و نام خانوادگی"
          value={_fullname}
          setValue={setFullname}
          inputProps={{ readOnly, placeholder: fullname }}
        />
        <TextInput
          style={{ maxWidth: 300 }}
          label="کد ملی"
          value={_nationalCode}
          setValue={setNationalCode}
          inputProps={{ readOnly, placeholder: national_code }}
        />
      </Row>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.Between}
        gap={20}
        flexWrap={Wrap.Wrap}
        className="customer-activity-popup-row"
      >
        <TextInput
          style={{ maxWidth: 300 }}
          label="تلفن همراه"
          value={_phone}
          setValue={setPhone}
          inputProps={{ readOnly, placeholder: phone }}
        />
        <TagInput
          label="تگ"
          value={_tags}
          setValue={setTags}
          style={{ maxWidth: 300 }}
          readOnly={readOnly}
        />
      </Row>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.Between}
        gap={20}
        flexWrap={Wrap.Wrap}
        className="customer-activity-popup-row"
      >
        <TextInput
          label="آدرس"
          value={_address}
          setValue={setAddress}
          className="customer-activity-popup-inp"
          inputProps={{ readOnly, placeholder: address }}
        />
      </Row>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.End}
        gap={20}
        flexWrap={Wrap.Wrap}
        className="customer-activity-popup-row"
      >
        <Button
          className="customer-activity-popup-btn"
          background={theme.primary}
          color={theme.textOnprimary}
          loading={loading}
          onClick={onEdit}
        >
          ویرایش
        </Button>
      </Row>
    </Column>
  );
};

export default CustomerEditPopup;
